import { LassoSelectionStates } from "types/lasso";

import { getLineChartFilteredItems } from "./utils";

export function getDeclineRateList({ params, series }: Partial<LassoSelectionStates>) {
  const isDateChart = true;
  const list = getLineChartFilteredItems(params, series, isDateChart);
  return list;
}
